// extracted by mini-css-extract-plugin
export default {"columnHeader":"Legal_columnHeader__lWnkJ","callRateDisclaimer":"Legal_callRateDisclaimer__SHWpy"};